import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { heatDiary as actions } from "actions/index";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { INPUT_FIELDS } from "./fields/heat_diary_prog";
import FormButtons from "components/form/FormButtons";

class HeatDiaryProgEntryForm extends Component {
  renderFields() {
    const { viewMode, editMode, values } = this.props;
    return INPUT_FIELDS.map((field, i) => {
      return (
        <Field
          key={i}
          values={values}
          viewMode={viewMode}
          editMode={editMode}
          {...field}
        />
      );
    });
  }

  render() {
    const { errors, dirty, isSubmitting, viewMode, editMode, cancel } =
      this.props;
    return (
      <Form>
        {this.renderFields()}
        <br />
        <FormButtons
          viewMode={viewMode}
          editMode={editMode}
          isSubmitting={isSubmitting}
          errors={errors}
          dirty={dirty}
          cancel={cancel}
          linkTo={"/userhome/dashboard/heat_diary"}
        />
        <br />
      </Form>
    );
  }
}

HeatDiaryProgEntryForm = withFormik({
  mapPropsToValues({ valuesToEdit, pet }) {
    return {
      type: valuesToEdit.type || "prog",
      date:
        moment(valuesToEdit.date).format("YYYY-MM-DD") ||
        moment().format("YYYY-MM-DD"),
      progesteroneLevel: valuesToEdit.progesteroneLevel || 0,
      progNotes: valuesToEdit.progNotes || "",
      _id: valuesToEdit._id || "",
      _pet: valuesToEdit._pet || pet._id,
    };
  },
  validationSchema: Yup.object().shape({
    date: Yup.date().required("required"),
    progesteroneLevel: Yup.number().required("required"),
    progNotes: Yup.string().max(500, "max-500"),
  }),
  handleSubmit(values, { props, setSubmitting }) {
    const successRoute = `${props.defaultRoute}/view_entries_prog`;
    if (props.editMode) {
      return props.updateHeatDiaryProgEntry(
        values,
        setSubmitting,
        props.history,
        successRoute
      );
    }
    props.addHeatDiaryProgEntry(
      values,
      setSubmitting,
      props.history,
      successRoute
    );
  },
})(HeatDiaryProgEntryForm);

export default withRouter(connect(null, actions)(HeatDiaryProgEntryForm));
